<template>
  <fin-dropdown :disabled="disabled"
                :dropdown-height="dropdownHeight"
                :items="sortedArchetypes"
                :value="selectedArchetypes"
                hide-all-selection
                label="Archetypen"
                show-selection-badge
                @input="val => selectedArchetypesChanged(val)">
    <template #default="{item}">
      <fin-archetype-avatar :archetype-id="item.id"
                            class="mr-3"
                            disable-tooltip/>
      <div>
        <p class="mb-0 mt-0">{{ item.title }}</p>
        <p v-if="highlightArchetypeId && item.id === highlightArchetypeId"
           :class="'mb-0 mt-n1 highlighted ' + item.id.toLowerCase()">
          {{ highlightText }}
        </p>
      </div>
    </template>
  </fin-dropdown>
</template>

<script>
import FinDropdown from "@/components/common/Dropdown"
import FinArchetypeAvatar from "@/components/common/ArchetypeAvatar"

export default {
  name: "finArchetypeDropdown",
  components: {FinArchetypeAvatar, FinDropdown},
  props: {
    /** The selected archetype objects */
    value: {
      type: Array,
      default: () => []
    },
    /** All available archetype objects */
    items: {
      type: Array,
      default: () => [],
      required: true,
    },
    /** The archetype ID to highlight */
    highlightArchetypeId: {
      type: String
    },
    /** The additional text to show for the highlighted archetype */
    highlightText: {
      type: String,
      default: 'Mein Archetyp'
    },
    /** Set if the highlighted archetype should be shown as first element */
    highlightAsFirst: {
      type: Boolean,
      default: false
    },
    /** Height of the dropdown */
    dropdownHeight: {
      type: String,
      default: '50vh'
    },
    /** Disables the v-menu dropdown */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedArchetypes: this.value
    }
  },
  computed: {
    sortedArchetypes() {
      let sortedArchetypes = [...this.items]

      if (this.highlightAsFirst && this.highlightArchetypeId) {
        let index = sortedArchetypes.findIndex(a => a.id === this.highlightArchetypeId)
        if (index !== -1) {
          // remove it from the array
          let removed = sortedArchetypes.splice(index, 1)
          // re-add it at the start of the array
          if (removed.length === 1) {
            sortedArchetypes.splice(0, 0, removed[0])
          }
        }
      }

      return sortedArchetypes
    }
  },
  methods: {
    selectedArchetypesChanged(archetypes) {
      this.selectedArchetypes = archetypes

      /**
       * Returns the changed selection of the archetypes
       */
      this.$emit('input', archetypes)
    }
  },
  watch: {
    value(val) {
      this.selectedArchetypes = val
    }
  }
}
</script>

<style lang="scss" scoped>
.highlighted {
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: var(--cool-grey);
}
</style>
